import s from '../allservices.jsx'
import { toast } from 'react-toastify';
import { getClientId, getClientSecret,buildClientHeader } from '../../utils/clientAuth.js';
const getFriendService = actionCallback => {
    const accountId = localStorage.getItem("accountId")
    let plink =  localStorage.getItem('pform')==='AU'? process.env.REACT_APP_SERVICEURL_AU : process.env.REACT_APP_SERVICEURL_NZ 
    let token = "Token " + localStorage.getItem('token')
    let traceId = getClientId();
    fetch(plink + s.get_friend + "/" + accountId , {
        headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': token,
            'X-Trace-Id': traceId,
            'X-KlickEx-Client':buildClientHeader(),
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            }  else {
                // 
                actionCallback(res.headers.get('message'),"error")
                toast.error(res.headers.get('message'), {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 2000,
                    newestOnTop: true,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                }); 
            }
        })
}

export default getFriendService;


// WEBPACK FOOTER //
// ./src/services/components/get_friends.jsx